import React, { FC, ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useJobSeeker } from '../../context/JobSeekerContext';
import { useAuth } from '../../hooks/useAuth';
import Loader from '../ui/Loader';
import DashboardLayout from './DashboardLayout';

interface JobSeekerLayoutProps {
  children: ReactNode;
}

const JobSeekerLayout: FC<JobSeekerLayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { isProfileComplete, incompleteStep, loadingState, isOnboardingPaymentDone } = useJobSeeker();

  useEffect(() => {
    if (user?.role === 'Jobseeker' && !loadingState.fetchData) {
      if (!isProfileComplete && incompleteStep != -1) {
        navigate(`/user/profile/complete?step=${incompleteStep}`, { replace: true });
      }
    }
  }, [user?.role, isProfileComplete, incompleteStep]);

  if (loadingState.fetchData) {
    return (
      <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Loader />
        <p className="mt-4 text-gray-600">Loading Details...</p>
      </div>
    </div>
    );
  }

  return (
    <DashboardLayout
      jobseekerDetails={{ isProfileCompleted : isProfileComplete , isOnboardingPaymentDone }}
    >
      {children}
    </DashboardLayout>
  );
};

export default JobSeekerLayout;
